export default __webpack_public_path__ + "static/shop-new-arrivals-mobile-370da838f29823f252b13767b149d497.png";